import React from 'react'
import { Tab } from 'react-bootstrap'
import Personal_Details from './personal_Details/Personal_Details'
import Driving_School_Details from './driving_School_Details/Driving_School_Details'
import Subscription_Plan from './subscription_Plan/Subscription_Plan'

function Tab_content_holder() {
    return (
        <>
            <section className='Account_Tab_content_holder'>
                <Tab.Content>
                    <Tab.Pane eventKey="Personal_Details"><Personal_Details /></Tab.Pane>
                    <Tab.Pane eventKey="Driving_School_Details"><Driving_School_Details /></Tab.Pane>
                    <Tab.Pane eventKey="Subscription_Plan"><Subscription_Plan /></Tab.Pane>
                </Tab.Content>
            </section>
        </>
    )
}

export default Tab_content_holder